import React, { useCallback } from 'react'
import { ItemEditor, TableEditor } from '@leverege/ui-attributes'
import { TabPane } from '@leverege/ui-elements'
import ShelfModel from '../ShelfModel'

export default function ShelfMonitoringEditor( props ) {
  const { onChange : pOnChange, value } = props

  const onChange = useCallback( ( { value : v, data, ...rest } ) => {
    const nValue = ShelfModel[data]( value, v )
    pOnChange( {
      ...rest,
      value : nValue
    } )
  }, [ pOnChange, value ] )

  return (
    <TabPane>
      <TabPane.Tab tabId="itemCard" tabName="Cards">
        <ItemEditor
          {...props}
          eventData="setSegments"
          value={value?.segments}
          onChange={onChange} />
      </TabPane.Tab>
      <TabPane.Tab tabId="table" tabName="Table">
        <TableEditor
          {...props}
          eventData="setTable"
          value={value?.table}
          onChange={onChange}
          objectType="product.event" />
      </TabPane.Tab>
    </TabPane>
  )
}
